"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrapper = exports.Content = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = require("@emotion/react");
var _breakpoints = _interopRequireDefault(require("../../globals/styles/breakpoints"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const wrapper = theme => /*#__PURE__*/(0, _react.css)("background-color:", theme.bgFooter, ";width:100%;padding:40px 0;" + (process.env.NODE_ENV === "production" ? "" : ";label:wrapper;"));
exports.wrapper = wrapper;
const Content = exports.Content = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e1329zf70"
} : {
  target: "e1329zf70",
  label: "Content"
})("display:flex;justify-content:space-between;max-width:1170px;margin:0 auto;@media screen and (max-width: ", _breakpoints.default.small, "){display:grid;grid-template-columns:1fr;grid-row-gap:2em;padding:0 1em;&>div{height:unset;}}");